'use client';

import { useCallback, useEffect, useState } from 'react';

export function useOptimizelyPurchaseCTAObserver(enabled = true) {
    const [sentinel, setSentinel] = useState<HTMLDivElement | null>(null);
    const [hasPassed, setHasPassed] = useState(false);
    const sentinelRef = useCallback((node: HTMLDivElement | null) => {
        setSentinel(node);
    }, []);

    useEffect(() => {
        if (!enabled) {
            setHasPassed(false);
            return;
        }

        if (!sentinel) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry) return;

            setHasPassed(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });

        observer.observe(sentinel);

        return () => observer.disconnect();
    }, [enabled, sentinel]);

    return { hasPassed, sentinelRef };
}
